<script setup lang="ts">
const { data, suspense } = useHomepage()

await suspense()

useHead({
  bodyAttrs: {
    class: 'bg-green-50',
  },
})
</script>

<template>
  <main id="main-content" class="flex flex-col justify-center">
    <HomeHero
      :products="data?.productCards"
      :title="data?.title"
    />
    <UiArticlesHighlighted
      v-if="data?.highlightedArticles?.articles?.length"
      :data="data?.highlightedArticles"
    />
    <ClientOnly>
      <UiStripesEvents />
      <UiStripesArticles
        class="yellow-light-green pb-16"
        title="Les siste nytt fra Aschehoug skole"
        :show-all="false"
        :no-top-margin="true"
        :range="[0, 3]"
      />
      <UiArticlesMostRead />
      <UiArticlesHomeMagazine />
    </ClientOnly>
    <UiStripesPodcasts
      v-if="data?.podcastCards.length"
      :podcasts="data?.podcastCards"
      class="sm:my-8"
    />
    <CardsAdvCard v-if="data?.advCard" :adv="data?.advCard" />
    <CtaNewsletter />
  </main>
</template>
